<template>
  <p v-html="displayValue"></p>
</template>
<script>
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "TimeDistance",
  computed: {
    displayValue() {
      function isDate(s) {
        if (isNaN(s) && !isNaN(Date.parse(s))) return true;
        else return false;
      }

      if (isDate(this.params.value) || this.params.value instanceof Date) {
        const targetDate = new Date(this.params.value);
        const today = new Date();
        const diffMs = targetDate - today;
        const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));

        const abs = Math.abs(diffDays);
        const past = diffDays < 0;

        let label;
        if (abs === 0) {
          return "today";
        } else if (abs === 1) {
          label = "1 day";
        } else if (abs < 7) {
          label = `${abs} days`;
        } else if (abs < 14) {
          label = "1 week";
        } else if (abs < 30) {
          label = `${Math.floor(abs / 7)} weeks`;
        } else if (abs < 60) {
          label = "1 month";
        } else if (abs < 365) {
          label = `${Math.floor(abs / 30)} months`;
        } else {
          const years = Math.floor(abs / 365);
          const months = Math.floor((abs % 365) / 30);
          label = months > 0
            ? `${years} ${years === 1 ? "year" : "years"} ${months} ${months === 1 ? "month" : "months"}`
            : `${years} ${years === 1 ? "year" : "years"}`;
        }

        return past ? `${label} ago` : `in ${label}`;
      } else {
        return this.params.value;
      }
    },
  },
});
</script>
